<div class="phone-container no-bottom-padding" style="color: #091e42">
  <div style="display: flex; flex-direction: row; gap: 10px; align-items: center">
    <mat-form-field appearance="none" class="remove-infix width-120">
      <div style="position: absolute; top: 15px; left: 40px">
        <div style="display: flex; gap: 10px; align-items: flex-end">
          <img
            *ngIf="selectedCountry?.phone == null"
            style="width: 20px; height: 20px; position: absolute; top: 0px; left: 25px"
            src="assets/img/flags/globe.svg"
            alt="globe"
          />
          <img
            *ngIf="selectedCountry?.phone != null"
            style="width: 20px; height: 20px"
            [src]="'assets/img/flags/' + selectedCountry.code.toLowerCase() + '.svg'"
            alt="{{ selectedCountry?.name }}"
            matTooltip="{{ selectedCountry?.name }}"
          />
        </div>
      </div>

      <mat-select
        name="country"
        #selectedCountryRef
        [value]="selectedCountry"
        class="text-style-input expanded-info-input-country"
        [errorStateMatcher]="countrySelectorErrorMatcher"
        (selectionChange)="onChangeCountry($event.value)"
      >
        <mat-option [value]="country" matTooltip="{{ country.name }}" *ngFor="let country of countriesFlagsPhones">
          <div class="text-style-input" style="display: flex; gap: 10px; align-items: center">
            <img
              *ngIf="country.code"
              [src]="'assets/img/flags/' + country.code.toLowerCase() + '.svg'"
              style="width: 20px; height: 20px"
            />
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div matInput class="text-style-input expanded-info-input-number">
      {{ selectedCountry.name }}
    </div>
  </div>
</div>
